import moment from 'moment';
import { ICustomerServicePackage } from './types/customer-service-package';

const EXPIRED_AT_FORMAT = 'MM/DD/YYYY';

/**
 * Gói còn hạn dùng. Hạn tính hết ngày expiredAt.
 * Parse lỗi thì coi như còn hạn: thà để nhân viên tự thấy còn hơn giấu gói của khách.
 */
export const isCustomerPackageNotExpired = (pkg: ICustomerServicePackage, now = moment()): boolean => {
  if (!pkg.expiredAt) return true;
  const expired = moment(pkg.expiredAt, EXPIRED_AT_FORMAT, true);
  if (!expired.isValid()) return true;
  return expired.endOf('day').isSameOrAfter(now);
};

/**
 * Gói dùng được: còn buổi, còn hạn, và biết giá một buổi.
 * Thiếu pricePerSession thì không tạo được dòng ticket nên loại luôn, tránh dòng giá NaN.
 */
export const filterUsableCustomerPackages = (
  packages: ICustomerServicePackage[] | null,
  now = moment(),
): ICustomerServicePackage[] =>
  (packages || []).filter(
    (pkg) =>
      (pkg.remainingQuantity ?? 0) > 0 &&
      typeof pkg.pricePerSession === 'number' &&
      isCustomerPackageNotExpired(pkg, now),
  );

/** Gói hết hạn sớm nhất đứng trước; cùng ngày thì theo id cho thứ tự ổn định giữa các lần render */
export const sortCustomerPackagesByExpiry = (packages: ICustomerServicePackage[]): ICustomerServicePackage[] =>
  [...packages].sort((a, b) => {
    const aTime = moment(a.expiredAt, EXPIRED_AT_FORMAT, true);
    const bTime = moment(b.expiredAt, EXPIRED_AT_FORMAT, true);
    const aValue = aTime.isValid() ? aTime.valueOf() : Number.MAX_SAFE_INTEGER;
    const bValue = bTime.isValid() ? bTime.valueOf() : Number.MAX_SAFE_INTEGER;
    if (aValue !== bValue) return aValue - bValue;
    return a.id.localeCompare(b.id);
  });
